import { getActivePinia } from "pinia";
import { isCompiledRenderSurface } from "%/dynamic-component-editor/classes/platform-standard-entities";

// The id of the destination's component called `name` ("Affiliate Link Card Small"), or 0. A published
// page reads the map its publish wrote; the builder reads the CreatorStudio DynamicComponent entities.
export function destinationComponentIdByName(name, destinationId) {
  if (!name) {
    return 0;
  }
  if (isCompiledRenderSurface()) {
    return Number(window.blclient?.data?.destinationComponents?.[name]) || 0;
  }
  const dcEntities = getActivePinia()?._s?.get?.("app-CreatorStudio-entities-DynamicComponent");
  if (!dcEntities) {
    return 0;
  }
  const entities = dcEntities.entities ?? dcEntities.$state?.entities ?? {};
  for (const entity of Object.values(entities)) {
    const data = entity?.fieldData;
    if (data?.type === "component" && data?.name === name) {
      const dcDestinationId = data?.destination?.pk?.id ?? data?.destination?.id;
      if (String(dcDestinationId) === String(destinationId)) {
        return data.id;
      }
    }
  }
  return 0;
}
